import { Select as StyledSelect, breakpoints } from '@gassan-ui'
import { useBreakpoint } from '@lib/hooks/useBreakpoint'
import { FC, useEffect, useState } from 'react'
import styled from 'styled-components'

type Props = {
  onChangeQuantity: (quantity: number) => void
  quantity: number
  disabled?: boolean
}

const Select = styled(StyledSelect)`
  z-index: 0;
  &:focus {
    z-index: 1;
  }
`

const SelectQuantity: FC<Props> = ({ onChangeQuantity, quantity, disabled = false }) => {
  const isDesktop = useBreakpoint(breakpoints.large)
  const [internalQuantity, setInternalQuantity] = useState<number>(quantity)
  const suffix = !isDesktop ? 'x' : ''

  useEffect(() => {
    setInternalQuantity(quantity)
  }, [quantity])

  const changeQuantity = (quantity: number) => {
    setInternalQuantity(quantity)
    onChangeQuantity(quantity)
  }

  return (
    <Select
      value={internalQuantity}
      onChange={(e) => changeQuantity(parseInt(e.target.value, 10))}
      disabled={disabled}
    >
      {[...Array(10)].map((_, i) => (
        <option key={i} value={i + 1}>
          {i + 1 + suffix}
        </option>
      ))}
    </Select>
  )
}

export default SelectQuantity
